import { getEffectiveThru, getMondayOfNextWeek } from "../common/util/util";

export interface PermitEnvelope {
    permits: Permit[];
    permitCount: number;
}
export interface DayTime {
    // step: number;
    day: number;
    time: Date;
}
export interface DropdownOption {
    key: string;
    text: string;
    value: string;
}
export interface Vehicle {
    id: string;
    permitVehicleId: number;
    make: string;
    model: string;
    year: number;
    licensePlateNbr: string;
    vehicleIsPrimary: boolean;
    vehicleSeqNbr: number;
    hovTransitVehicleNbr: string;
    transitAgency: string;
    orderSeq: number;
}
export interface Agrees {
    agreed1: boolean;
    agreed2: boolean;
    error: string;
}
export class AgreeFormValues implements Agrees {
    agreed1: boolean = false;
    agreed2: boolean = false;
    error: string = '';
}
export interface Workdest {
    workdestCompany: string;
    workdestAddress: string;
    workdestAddress2: string;
    workdestCity: string;
    workdestState: string;
    workdestZipcode: string;
    workdestPhone: string;
}
export class UserPermitDetailValues implements UserPermitDetail {
    permitDetailId: number = 0;
    wsdoTPermitNbr: string = '';
    effectiveThru: Date = new Date();
}
export class WorkdestFormValues implements Partial<Workdest> {
    workdestCompany: string = '';
    workdestAddress: string = '';
    workdestAddress2: string = '';
    workdestCity: string = '';
    workdestState: string = 'WA';
    workdestZipcode: string = '';
    workdestPhone: string = '';
}
export interface Rider {
    id: string;
    permitRiderId?: number;
    firstName: string;
    lastName: string;
    address: string;
    address2: string;
    city: string;
    zipcode: string;
    phone: string;
    employerName: string;
    employerCity: string;
    employerZipcode: string;
}
export class RiderFormValues implements Partial<Rider> {
    id: string = '';
    firstName: string = '';
    lastName: string = '';
    address: string = '';
    address2: string = '';
    city: string = '';
    zipcode: string = '';
    phone: string = '';

    employerName: string = '';
    employerCity: string = '';
    employerZipcode: string = '';

    constructor(init?: Rider) {
        Object.assign(this, init);
    }
}
export interface DepartingTime {
    day_id: string;
    time_id: string;
    times: [];
}
export interface Sailing {
    permitRoutetimeId: number; //day_id? or time_id
    terminalId: number;
    dayId: number;
    weekId: number;
    isSelected: boolean;
}
export interface Permit {
    id: number;
    permitId: number;
    subscriberID: number;
    permitTypeId: number;
    effectiveThru: Date;
    dateWeekBegin: Date;
    permitDetail: UserPermitDetail;

    isFinalView: boolean;
    amTimes: SailingValues[];
    am2Times: SailingValues[];
    pmTimes: SailingValues[];
    pm2Times: SailingValues[];
    
    routeId: string;
    step: number;

    amTerminalId: string;
    pmTerminalId: number;
    scheduleTypeInd: string;

    customerScheduleComment: string;
    vehicles: Vehicle[];
    riders: Rider[];
    sailingTimes: Sailing[];

    workdestCompany: string;
    workdestAddress: string;
    workdestAddress2: string;
    workdestCity: string;
    workdestState: string;
    workdestZipcode: string;
    workdestPhone: string;
}
export class PermitFormValues implements Partial<Permit> {
    id: number = 0;
    step: number = 0; // initial permit step
    isFinalView: boolean = false;
    riderEditMode: number = -1;
    vehicleEditMode: number = -1;

    permitTypeId: number = 0;
    routeId: string = '';
    amTerminalId: string = '';
    pmTerminalId: number = 0;
    scheduleTypeInd: string = '1'; // 1 = same schedule , 2 = alternative schedule

    dateWeekBegin: Date = getMondayOfNextWeek();

    // dynamically add dropdown props
    customerScheduleComment: string = '';
    amTimes: SailingValues[] = [];
    am2Times: SailingValues[] = [];
    pmTimes: SailingValues[] = [];
    pm2Times: SailingValues[] = [];

    // step 3 - workdestCompany
    // workdest: Workdest = <Workdest>{};
    workdestCompany: string = '';
    workdestAddress: string = '';
    workdestAddress2: string = '';
    workdestCity: string = '';
    workdestState: string = 'WA';
    workdestZipcode: string = '';
    workdestPhone: string = '';

    // step 4 - Vehicle info
    vehicles: Vehicle[] = [];

    // step 5 - rider info
    riders: Rider[] = [];

    // for permit edit form
    permitId: number = 0;
    subscriberID: number = 0;
    permitDetail: UserPermitDetailValues = new UserPermitDetailValues();
    // permit details
    effectiveThru: Date = getEffectiveThru(); // new form for client side
    sailingTimes: Sailing[] = [];
    error: string = '';

    constructor(init?: Permit) {
        for(var i: number = 0; i <= 6; i++) {
            // week 1
            this.amTimes[i] = new SailingValues();
            this.amTimes[i].dayId = i + 1;
            this.amTimes[i].weekId = 1;
            this.amTimes[i].permitRoutetimeId = 0;

            this.pmTimes[i] = new SailingValues();
            this.pmTimes[i].dayId = i + 1;
            this.pmTimes[i].weekId = 1;
            this.pmTimes[i].permitRoutetimeId = 0;

            // week 2
            this.am2Times[i] = new SailingValues();
            this.am2Times[i].dayId = i + 1;
            this.am2Times[i].weekId = 2;
            this.am2Times[i].permitRoutetimeId = 0;

            this.pm2Times[i] = new SailingValues();
            this.pm2Times[i].dayId = i + 1;
            this.pm2Times[i].weekId = 2;
            this.pm2Times[i].permitRoutetimeId = 0;
        }

        // initialize sailing times
        if (init && init.sailingTimes.length > 0) {
            // set am
            init.sailingTimes.forEach((s) => {
                // also week 1 vs week 2
                // should use [][]
                // week 1
                if (s.weekId === 1) {
                    if(s.terminalId === +init.amTerminalId) {
                        this.amTimes[s.dayId - 1].weekId = s.weekId;
                        this.amTimes[s.dayId - 1].terminalId = s.terminalId;
                        this.amTimes[s.dayId - 1].permitRoutetimeId = s.permitRoutetimeId;
                        this.amTimes[s.dayId - 1].isSelected = true;
                    }else {
                        this.pmTimes[s.dayId - 1].weekId = s.weekId;
                        this.pmTimes[s.dayId - 1].terminalId = s.terminalId;
                        this.pmTimes[s.dayId - 1].permitRoutetimeId = s.permitRoutetimeId;
                        this.pmTimes[s.dayId - 1].isSelected = true;
                    }
                }else {
                    if(s.terminalId === +init.amTerminalId) {
                        this.am2Times[s.dayId - 1].weekId = s.weekId;
                        this.am2Times[s.dayId - 1].terminalId = s.terminalId;
                        this.am2Times[s.dayId - 1].permitRoutetimeId = s.permitRoutetimeId;
                        this.am2Times[s.dayId - 1].isSelected = true;
                    }else {
                        this.pm2Times[s.dayId - 1].weekId = s.weekId;
                        this.pm2Times[s.dayId - 1].terminalId = s.terminalId;
                        this.pm2Times[s.dayId - 1].permitRoutetimeId = s.permitRoutetimeId;
                        this.pm2Times[s.dayId - 1].isSelected = true;
                    }
                }
            });
        }
        Object.assign(this, init);
    }
}
export class VehicleFormValues implements Partial<Vehicle> {
    id: string = '';
    permitVehicleId: number = 0;
    make: string = '';
    model: string = '';
    year: number = 0;
    licensePlateNbr: string = '';
    vehicleSeqNbr: number = 0;
    vehicleIsPrimary: boolean = false;
    orderSeq: number = 0;
    hovTransitVehicleNbr: string = '';
    transitAgency: string = '';

    constructor(init?: Vehicle) {
        Object.assign(this, init);
    }
}
export class SailingValues implements Sailing {
    permitRoutetimeId: number = 0;
    dayId: number = 0;
    weekId: number = 0;
    terminalId: number = 0;
    isSelected: boolean = false;
}

export interface UserPermitEnvelope {
    permits: Permit[];
    permitCount: number;
}

export interface UserPermitDetail {
    permitDetailId: number;
    wsdoTPermitNbr: string;
    effectiveThru: Date;
}
